export default function IsValidDescricao(descricao) {
  return descricao && typeof descricao === 'string'
    && descricao.length >= 10;
}